import { actions } from 'api/actions';
import { endpoints } from 'api/endpoints';
import { EntryMode, isExistingSiteEntryMode } from 'config/entry-mode';
import { useAppStore } from 'stores/appStore';
import { SequentialTaskItem } from '@wix/gg-common-lib/hooks';

export function getStoreSetupTaskGroups(entryMode: EntryMode): SequentialTaskItem[] {
  if (isExistingSiteEntryMode(entryMode)) {
    return getExistingSiteStoreSetupTaskGroups();
  }

  return getNetNewStoreSetupTaskGroups();
}

function getNetNewStoreSetupTaskGroups(): SequentialTaskItem[] {
  return [
    [
      { task: actions.attachSiteTemplate },
      {
        task: async () => {
          await endpoints.deleteAllProducts();
        },
      },
      { task: actions.uploadSiteMedia },
    ],
    [
      { task: actions.addStoreProducts },
      { task: actions.updateSiteName },
      { task: actions.injectSiteNameComponent, retries: 20 },
    ],
    {
      task: async () => {
        await endpoints.publishSite();
      },
    },
    [
      { task: actions.validateCatalogProductsCount, retries: 20 },
      { task: actions.fetchSiteUrl, retries: 10 },
    ],
  ];
}

function getExistingSiteStoreSetupTaskGroups(): SequentialTaskItem[] {
  return [
    [{ task: actions.prepareExistingSiteStore }, { task: actions.uploadSiteMedia }],
    [{ task: actions.addStoreProducts }],
  ];
}

export function resolveStoreSetupEntryMode(): EntryMode {
  return useAppStore.getState().entryMode;
}
